// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Precalc__precalc___dnz{text-align:center}.Precalc__precalc___dnz>div{margin:-45px auto 30px}`, "",{"version":3,"sources":["webpack://./components/Valuation/Precalc.scss"],"names":[],"mappings":"AAEA,wBACI,iBAAA,CACA,4BACI,sBAAA","sourcesContent":["@import '../../vars.scss';\n\n.precalc {\n    text-align: center;\n    & > div {\n        margin: -45px auto 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"precalc": `Precalc__precalc___dnz`
};
export default ___CSS_LOADER_EXPORT___;
